"use client";

import { FC } from "react";
import { IBannerResponse } from "@finbackoffice/clientbff-client";
import ErrorBoundary from "components/base/error-boundary/ErrorBoundary";
import Home from "components/home/Home";
import { IReelsDataState } from "../../types/reels.data";

type Props = {
    reels: IReelsDataState | null;
    banners: IBannerResponse[];
};

export const HomeScreen: FC<Props> = ({ reels, banners }) => {
    return (
        <ErrorBoundary name={Home.name}>
            <Home reels={reels} banners={banners} />
        </ErrorBoundary>
    );
};
